// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_tlG","cls2":"Comments-cls2_TZr Comments-cls1_tlG"};